module.exports = __webpack_public_path__ + "5941f0a9e3a97240f3d1d7fc6a8e1e8a.fbx";